import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './EventHeader.css';
import React, { useState, Fragment, useEffect, useMemo } from 'react';
import { differenceInDays } from 'date-fns';
import { canUseDOM, get, getGlobalDictionaryTerm } from '../../utils';
import StickyCtaAssistant from '../../utils/StickyCtaAssistant';
import Reminder from '../atoms/Reminder/Reminder';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import makeUrls from './makeUrls';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
/* import AddToCalendar, { DropdownOuter } from './AddToCalendar'; */
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import closeWhite from '../../resources/icons/close-white.svg';
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import LazyPicture from '../atoms/LazyPicture';
import { ReactComponent as ChevronRightLight } from '../../resources/icons/chevron-right-light.svg';
import { ReactComponent as LocationBlue } from '../../resources/icons/location-blue.svg';
import { ReactComponent as Ticket } from '../../resources/icons/ticket.svg';
import { ReactComponent as ReminderIcon } from '../../resources/icons/icon-reminder.svg';
import { ReactComponent as IconClose } from '../../resources/icons/close.svg';
import { ReactComponent as PlusIcon } from '../../resources/icons/icon-plus-round.svg';
import { ReactComponent as MinusIcon } from '../../resources/icons/icon-minus-round.svg';
import { ReactComponent as EmailBigIcon } from '../../resources/icons/email-large.svg';
import { ReactComponent as CalendarBigIcon } from '../../resources/icons/calendar-large.svg';
import { ReactComponent as IconChevronDown } from '../../resources/icons/IconChevronDown.svg';
import arrowLeftnoborderWhite from '../../resources/icons/arrow-left-noborder-white.svg';
import RouterLink from '../atoms/RouterLink';
import { Scrollbars } from 'react-custom-scrollbars-2';
// import GoogleMap, { defaultMapState } from '../atoms/GoogleMaps/GoogleMaps';
// import getPlaceInfoByID from '../atoms/GoogleMaps/GooglePlaceService';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import ChevronUp from '../atoms/Icons/IconChevronUp';
import { tealiumClickFunc, tealiumMergeClickData, tealiumClickFuncExtended } from '../../utils/tealium';
// import loadable from '@loadable/component';
import EventPopup from './EventPopup';
import { getLatestUserCookie } from '../Login/user_session';
import { convertToAnalyticObject } from '../../utils/analytics';

// const Scrollbars = loadable(() => import('react-custom-scrollbars'), { ssr: false });

var createRouterLink = function createRouterLink(buyLink, accessToken, venueWebsite, isTicketing) {
  if (buyLink) {
    return isTicketing ? accessToken ? buyLink + accessToken : "/login?redirect_url=".concat(buyLink) : buyLink;
  } else {
    return venueWebsite;
  }
};
var reminderAccordionInitialState = {
  visible: false,
  visibleArea: 'email',
  isEmailBlockHidden: false
};
var calendarReminderInitialState = {
  visible: false,
  selectedString: '',
  value: ''
};
export var EventHeader = function EventHeader(_ref) {
  var fields = _ref.fields,
    rendering = _ref.rendering,
    children = _ref.children,
    params = _ref.params,
    route = _ref.route;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    activateEvents = _useState2[0],
    setactivateEvents = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    accessToken = _useState4[0],
    setAccessToken = _useState4[1];
  var _useState5 = useState({
      google: '',
      outlook: '',
      yahoo: '',
      ics: ''
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    currentUrls = _useState6[0],
    setCurrentUrls = _useState6[1];
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isChina = _React$useState2[0],
    setIsChina = _React$useState2[1];
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var currentLang = get(sitecoreContext, 'language');
  var moduleId = get(fields, 'data.item.id');
  var eventArchived = get(route, 'fields.Archived.value');
  var isTicketing = get(route, 'fields.Is Ticketing.value');
  var theme = get(sitecoreContext, 'themesOfPage');
  var newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  var setReminderLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderSetReminder') || 'Set reminder';
  var editLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderEdit') || 'Edit';
  var emailReminderLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderEmailReminder') || 'Email reminder';
  var calendarReminderLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderCalendarReminder') || 'Calendar reminder';
  var accordeonIntroLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderEmailReminderText') || 'An email will be sent to your inbox as a reminder';
  var selectMediaLabel = getGlobalDictionaryTerm(sitecoreContext, 'ReminderSelect') || 'Select';
  var ReminderGoogle = getGlobalDictionaryTerm(sitecoreContext, 'ReminderGoogle') || 'ReminderGoogle';
  var ReminderOutlookWebApp = getGlobalDictionaryTerm(sitecoreContext, 'ReminderOutlookWebApp') || 'ReminderOutlookWebApp';
  var ReminderOutlook = getGlobalDictionaryTerm(sitecoreContext, 'ReminderOutlook') || 'ReminderOutlook';
  var ReminderYahoo = getGlobalDictionaryTerm(sitecoreContext, 'ReminderYahoo') || 'ReminderYahoo';
  var serverRole = get(sitecoreContext, 'configuration.serverRole');
  var eventTags = get(fields.data.item.tags, "targetItems", []);
  var notContainBusinessEventTag = !eventTags.some(function (tag) {
    return tag.name === "Business event";
  });
  var _useState7 = useState(rtl),
    _useState8 = _slicedToArray(_useState7, 2),
    hideEvents = _useState8[0],
    sethideEvents = _useState8[1];
  var scrollRef = /*#__PURE__*/React.createRef();
  var buttonRef = /*#__PURE__*/React.createRef();

  // const medias: any = get(ListicleMedia, 'fields.data.item.mediaItems');
  var placeholdersItems = get(rendering, 'placeholders.media-header-general') || [];
  var eventDateString = get(fields, 'data.item.eventDates.jss.value');
  var eventDates = Boolean(eventDateString) && JSON.parse(eventDateString).dates || [];
  var currentDate = new Date(new Date().getTime() - 24 * 60 * 60 * 1000).toISOString();
  var dateStart = '';
  var dateEnd = '';
  var validEvents = eventDates.filter(function (arr) {
    var stDate = String(get(arr, 'Date')) || '';
    var edDate = String(get(arr, 'DateTo', ''));
    var edDateValid = edDate ? edDate : stDate;
    if (stDate && !dateStart) {
      dateStart = stDate;
    }
    if (edDate && !dateEnd) {
      dateEnd = edDate;
    }
    if (stDate >= currentDate || edDateValid >= currentDate) {
      return arr;
    }
  });
  var setDateFormat = function setDateFormat(date, enFormat) {
    return new Date(date).toLocaleDateString(currentLang === 'en' || enFormat ? 'en-GB' : currentLang, {
      weekday: 'short',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      numberingSystem: 'latn'
    });
  };
  var dateAnalytics = "".concat(dateStart ? setDateFormat(dateStart, true) : '').concat(dateStart && dateEnd ? ' - ' : '').concat(dateEnd ? setDateFormat(dateEnd, true) : '');
  var curatorString = get(fields, 'data.item.curators.jss.value');
  var curators = Boolean(curatorString) && JSON.parse(curatorString).curators;
  var introText = get(fields, 'data.item.introText.jss');
  var defaultAddress = get(fields, 'data.item.address.jss.value');
  var title = get(fields, 'data.item.title.jss');
  var titleForAnalytics = get(fields, 'data.item.titleAnalytics.jss');
  var tagName = get(fields, 'data.item.tag.targetItem.title.jss.value');
  var tagNameForAnalytics = get(fields, 'data.item.tag.targetItem.titleAnalytics.jss.value');
  var buyLink = get(fields, 'data.item.buyLink.jss.value.href');
  var buyLinkMobile = get(fields, 'data.item.buyLinkMobile.jss.value.href');
  var name = get(fields, 'data.item.name');
  var hasGooglePlaceIDCollection = Boolean(get(fields, 'data.item.googlePlaceIDCollection.googlePlaceIds.length'));
  var googleMapUrl = 'https://www.google.com/maps/place/?q=place_id:';
  var googlePlaceIDCollection = hasGooglePlaceIDCollection ? get(fields, 'data.item.googlePlaceIDCollection.googlePlaceIds') : [];
  var placeIDfallback = get(googlePlaceIDCollection[0], 'name', '');
  var address = get(fields, 'data.item.address.jss', '');
  var parentEventLogo = get(fields, 'data.item.parentEvent.targetItem.logo.src');
  var parentEventLogoLink = get(fields, 'data.item.parentEvent.targetItem.url');
  var BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  var hasVenues = Boolean(get(fields, 'data.item.venue.values.length'));
  var _ref2 = hasVenues ? get(fields, 'data.item.venue.values') : [],
    _ref3 = _slicedToArray(_ref2, 1),
    venue = _ref3[0];
  var venueValues = hasVenues ? get(fields, 'data.item.venue.values') : [];
  var ticketPrice = get(fields, 'data.item.ticketPrice.jss.value', '');
  var isFree = Boolean(get(fields, 'data.item.isFree.boolValue'));
  var ticketsAvailable = get(fields, 'data.item.ticketsAvailable.jss.value');
  var minPrice = get(fields, 'data.item.minPrice.jss.value', '');
  var maxPrice = get(fields, 'data.item.maxPrice.jss.value', '');
  var venueWebsite = get(fields, 'data.item.website.jss.value.href', '');
  var tickets = get(fields, 'data.item.tickets', []);
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    ticketsDdVisible = _useState10[0],
    setTicketsDdVisible = _useState10[1];
  var countryItems = get(fields, 'data.countries.countryValues') || [];
  var _useState11 = useState(reminderAccordionInitialState),
    _useState12 = _slicedToArray(_useState11, 2),
    reminderAccordionState = _useState12[0],
    setReminderAccordionState = _useState12[1];
  var _useState13 = useState(calendarReminderInitialState),
    _useState14 = _slicedToArray(_useState13, 2),
    calendarReminderState = _useState14[0],
    setCalendarReminderState = _useState14[1];
  var _useState15 = useState({}),
    _useState16 = _slicedToArray(_useState15, 2),
    eventForReminder = _useState16[0],
    setEventForReminder = _useState16[1];
  var dictionaryForCurators = get(fields, 'data.dictionary.dictionaryValues') || [];
  var dictionary = (get(fields, 'data.dictionary.dictionaryValues') || []).concat(dictionaryForCurators);
  var dictionaries = Boolean(dictionary) && dictionary.reduce(function (aggregator, currentValue) {
    return aggregator.set(currentValue.key.jss && currentValue.key.jss.value, currentValue.phrase.jss && currentValue.phrase.jss.value);
  }, new Map());
  var imagesAndVideos = [];
  var singleVenueAddress = get(venueValues[0], 'title.jss.value');
  var singleVenuePlaceID = get(venueValues[0], 'googlePlaceID.jss.value');
  var placeInfoRef = React.useRef(null);
  // const [mapState, setMapState] = React.useState(defaultMapState);
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    locationIcon = _React$useState4[0],
    setLocationIcon = _React$useState4[1];
  // const [placeID, setPlaceID] = React.useState<string>('');
  var _React$useState5 = React.useState(true),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    showLocationIcon = _React$useState6[0],
    setShowLocationIcon = _React$useState6[1];

  // const apiReady = () => {
  //   const googlePlaceID: string = placeIDfallback ? placeIDfallback : singleVenuePlaceID; //dubai place id
  //
  //   if (googlePlaceID) {
  //     // setShowLocationIcon(false);
  //     getPlaceInfoByID(googlePlaceID, placeInfoRef.current, (place: any) => {
  //       const locationPlaceID = get(place, 'formatted_address');
  //       setPlaceID(locationPlaceID);

  //     });
  //   }
  // };

  useEffect(function () {
    getLatestUserCookie().then(function (value) {
      var userCookie = value;
      if (userCookie && userCookie.login_status) {
        if (userCookie.access_token) {
          setAccessToken("&dtcm_access_token=".concat(userCookie.access_token));
        }
      }
    });
  }, []);
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isOpenReminderCalendarPicker = _useState18[0],
    setIsOpenReminderCalendarPicker = _useState18[1];
  var eventObjForReminder = useMemo(function () {
    var imageSet = !!placeholdersItems.length;
    var imageField = imageSet ? get(placeholdersItems[0], 'fields.data.item') : '';
    var eventImage = !!imageField || '';
    if (imageField) {
      var imagesArray = get(imageField, 'children');
      if (imagesArray && imagesArray.length) {
        eventImage = get(imagesArray[0], 'image.jss.value.src');
      } else {
        eventImage = get(imageField, 'image.jss.value.src');
      }
    }
    return {
      objectID: moduleId,
      title: title && title.value,
      introText: introText && introText.value,
      location: address && address.value,
      url: canUseDOM ? window.location.href : '',
      category: tagName,
      image: eventImage,
      type: ['Event']
    };
  }, []);
  useEffect(function () {
    if (typeof document !== 'undefined') {
      var urlParams = new URLSearchParams(document.location.search);
      var isC = Boolean(urlParams.get('isChina') === 'true');
      setIsChina(isC);
    }
  }, []);
  var _fields$data = fields.data,
    addToCalendarClickAnalytics = _fields$data.addToCalendarClickAnalytics,
    buyTicketsClickAnalytics = _fields$data.buyTicketsClickAnalytics,
    addToFavAnalytics = _fields$data.addToFavAnalytics,
    locationAnalytics = _fields$data.locationAnalytics,
    seeAllDatesClickAnalytics = _fields$data.seeAllDatesClickAnalytics,
    sliderAnalytics = _fields$data.sliderAnalytics,
    buyMultipleTicketsClickAnalytics = _fields$data.buyMultipleTicketsClickAnalytics,
    buyNowMultipleTicketsClickAnalytics = _fields$data.buyNowMultipleTicketsClickAnalytics;
  var eAnalytics = get(fields, 'data.eventsAnalytics');
  var eventsAnalytics;
  if (eAnalytics) {
    eventsAnalytics = convertToAnalyticObject(eAnalytics);
  }
  var getMonth = function getMonth(date) {
    return new Date(date).getMonth();
  };
  var getMonthAndYear = function getMonthAndYear(date) {
    var month = new Date(date).getMonth();
    var year = new Date(date).getFullYear();
    return "".concat(month, ",").concat(year);
  };
  var monthsFull = new Array();
  for (var i = 1; i <= 12; i++) {
    var month = new Date("1999/".concat(i, "/1")).toLocaleDateString(currentLang, {
      month: 'long'
    });
    monthsFull.push(month);
  }
  var monthsShort = new Array();
  for (var _i = 1; _i <= 12; _i++) {
    var _month = new Date("1999/".concat(_i, "/1")).toLocaleDateString(currentLang === 'en' ? 'en-GB' : currentLang, {
      month: 'short'
    });
    monthsShort.push(_month);
  }
  var renderCurators = function renderCurators() {
    if (!curators) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "curators__block"
    }, /*#__PURE__*/React.createElement("div", {
      className: "curators__row"
    }, curators && curators.map(function (curator) {
      return /*#__PURE__*/React.createElement("img", {
        className: "curators__image-item",
        src: "".concat(curator.Image && curator.Image.includes(BASE_URL) ? '' : BASE_URL).concat(curator.Image, "&cw=22&ch=22"),
        alt: curator.Name
      });
    })), /*#__PURE__*/React.createElement("div", {
      className: "curators__author"
    }, dictionaries.get('CuratorsPick')));
  };
  var renderPriceBlock = function renderPriceBlock() {
    if (isFree) {
      return dictionaries.get('FreeEvent');
    }
    if (rtl) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, !isFree && !minPrice && !minPrice && ticketPrice ? /*#__PURE__*/React.createElement(React.Fragment, null, ticketPrice) : /*#__PURE__*/React.createElement(React.Fragment, null, !isFree && ticketsAvailable && (minPrice || minPrice) ? dictionaries.get('TicketsAvailableFrom') : dictionaries.get('TicketPriceFrom'), !isFree && (minPrice || minPrice) && ' ' + minPrice + ' ' + dictionaries.get('AED'), !isFree && minPrice ? "".concat(maxPrice ? ' - ' + maxPrice + ' ' + dictionaries.get('AED') : '') : "".concat(minPrice ? ' - ' + minPrice : ' - ' + ticketPrice, " ")));
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, !isFree && !minPrice && !minPrice && ticketPrice ? /*#__PURE__*/React.createElement(React.Fragment, null, ticketPrice) : /*#__PURE__*/React.createElement(React.Fragment, null, !isFree && ticketsAvailable && (minPrice || minPrice) ? dictionaries.get('TicketsAvailableFrom') : dictionaries.get('TicketPriceFrom'), !isFree && (minPrice || minPrice) && ' ' + dictionaries.get('AED') + ' ', !isFree && minPrice ? "".concat(minPrice, " ").concat(maxPrice ? ' - ' + dictionaries.get('AED') + ' ' + maxPrice : '') : "".concat(minPrice ? minPrice : ticketPrice, " ")));
    }
  };
  var showEvents = function showEvents(e) {
    e.preventDefault();
    setactivateEvents('show-events');
  };
  var closeEvents = function closeEvents(e) {
    e.preventDefault();
    setactivateEvents('');
  };
  /* eslint-disable  */
  var renderItems = function renderItems() {
    if (placeholdersItems) {
      return placeholdersItems.map(function (item) {
        var imageSrc = get(item, 'fields.data.item.image.jss.value.src');
        var imageAlt = get(item, 'fields.data.item.image.jss.value.alt');
        return /*#__PURE__*/React.createElement(LazyPicture, {
          className: "styled-curved-image",
          useEmptyPlaceholder: true
        }, /*#__PURE__*/React.createElement("source", {
          media: "(min-width:769px)",
          srcSet: "".concat(BASE_URL + imageSrc, "&cw=795&ch=595")
        }), /*#__PURE__*/React.createElement("img", {
          src: "".concat(BASE_URL + imageSrc, "&cw=795&ch=595"),
          alt: imageAlt
        }));
      });
    }
    return [];
  };
  /* eslint-enable  */
  var getDate = function getDate(date) {
    var day = new Date(date).getDate();
    return !Number.isNaN(day) && day < 10 ? '0' + day.toString() : day.toString();
  };
  var getYear = function getYear(date) {
    return new Date(date).getFullYear();
  };
  var renderListDate = function renderListDate() {
    var dateRanges = [];
    validEvents.forEach(function (date) {
      if (dateRanges.some(function (el) {
        return getMonthAndYear(el.key) === getMonthAndYear(date.Date);
      })) {
        dateRanges.find(function (el) {
          return getMonthAndYear(el.key) === getMonthAndYear(date.Date);
        }).values.push(date);
      } else {
        dateRanges.push({
          key: date.Date,
          values: [date]
        });
      }
    });
    if (!dateRanges) {
      return null;
    }
    return dateRanges && dateRanges.map(function (date, index) {
      return /*#__PURE__*/React.createElement(Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "events-overlay__month-n-year"
      }, "".concat(monthsFull[Number(getMonth(date.key))], " ").concat(getYear(date.key))), renderEventDates(undefined, date.values, venue));
    });
  };
  var renderEventDates = function renderEventDates(eventNumbers, eventD, venue) {
    if (!eventD) {
      return null;
    }
    //Commented code below can be deleted after S26 || september 2024
    // const isDateDisable = (start: Date) => {
    //   const lastPossibleDateForOneReminder = new Date(start);
    //   lastPossibleDateForOneReminder.setDate((new Date(start)).getDate());
    //   const reminder1Stamp = lastPossibleDateForOneReminder.getTime();
    //   const nowStamp = Date.now();
    //   return nowStamp > reminder1Stamp;
    // }

    var venueTitle = get(title, 'value');
    var venueDetails = get(introText, 'value');
    var venueAddress = get(venue, 'address.jss.value');
    var numberOfItemsToRender = eventNumbers;
    return eventD && eventD.slice(0, numberOfItemsToRender).map(function (date, index) {
      var eventDate = get(date, 'Date') || '';
      var eventDateTo = get(date, 'DateTo') || '';
      var eventTimeStartCheck = get(date, 'TimeStart');
      var eventTimeEndCheck = get(date, 'TimeEnd');
      var eventTimeStart = get(date, 'TimeStart') || '00:00:00';
      var eventTimeEnd = get(date, 'TimeEnd') || '00:00:00';
      var eventDateFull = eventDate && eventDate.substring(0, 10) + 'T' + eventTimeStart.substring(0, 5) + '+04:00';
      var eventDateToFull = eventDateTo && eventDateTo.substring(0, 10) + 'T' + eventTimeEnd.substring(0, 5) + '+04:00';
      /* Event Dates End*/
      /* const reminderButtonDisabled = isDateDisable(new Date(`${eventDate} ${eventTimeStart}`)); */

      //  this line no longer needed because of new logic and can be deleted after S26 || september 2024) 
      var numberOfDaysBeforeEventEnd = differenceInDays(new Date(eventDateTo !== '' ? eventDateTo : eventDate), currentDateFormatted);
      var numberOfDaysBeforeEventStart = differenceInDays(new Date(eventDate && eventDate), currentDateFormatted);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "header-event-list",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-event-list__date"
      }, eventDate >= currentDate, eventDate && getDate(eventDate), /*#__PURE__*/React.createElement("span", {
        className: "header-event-list__month"
      }, eventDate && monthsShort[Number(getMonth(eventDate))])), eventDateTo && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "event-separator"
      }), /*#__PURE__*/React.createElement("div", {
        className: "header-event-list__date"
      }, getDate(eventDateTo), /*#__PURE__*/React.createElement("span", {
        className: "header-event-list__month"
      }, eventDateTo && monthsShort[Number(getMonth(eventDateTo))]))), /*#__PURE__*/React.createElement("div", {
        className: "header-event-list__content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-event-list__complete-date"
      }, eventDate && setDateFormat(eventDate)), /*#__PURE__*/React.createElement("div", {
        className: "header-event-list__days"
      }, eventTimeStartCheck && eventTimeStartCheck.substring(0, 5), eventTimeEndCheck && ' - ' + eventTimeEndCheck.substring(0, 5)), (eventDate || eventDateTo) && notContainBusinessEventTag && /*#__PURE__*/React.createElement("button", {
        className: "reminder-accordion-opener btn--reset",
        disabled: numberOfDaysBeforeEventEnd <= 0,
        onClick: function onClick() {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['SetReminderOpenClickAnalytics'], params), "".concat(get(fields, 'data.item.title.jss.value', ''), " : event detail"));
          setReminderAccordionState(_objectSpread(_objectSpread({}, reminderAccordionState), {}, {
            visible: true
          }));
          setEventForReminder(_objectSpread(_objectSpread({}, eventObjForReminder), {}, {
            detailEventTimeStart: eventTimeStart,
            detailEventDateStart: eventDate,
            detailEventDateEnd: eventDateTo,
            numberOfDaysBeforeEventEnd: numberOfDaysBeforeEventEnd
          }));
          if (numberOfDaysBeforeEventEnd === 1 || numberOfDaysBeforeEventStart === 1) {
            setReminderAccordionState(function (prevState) {
              return _objectSpread(_objectSpread({}, prevState), {}, {
                visibleArea: 'calendar',
                isEmailBlockHidden: true
              });
            });
          } else {
            setReminderAccordionState(function (prevState) {
              return _objectSpread(_objectSpread({}, prevState), {}, {
                visibleArea: 'email',
                isEmailBlockHidden: false
              });
            });
          }
          var newUrls = makeUrls({
            name: "".concat(venueTitle),
            details: "".concat(venueDetails),
            location: "".concat(venueAddress),
            startsAt: "".concat(eventDateFull),
            endsAt: "".concat(eventDateToFull ? eventDateToFull : eventDateFull)
          });
          setCurrentUrls(newUrls);
        }
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(ReminderIcon, {
        className: "icon-calendar"
      }), " ", setReminderLabel)))));
    });
  };
  /* eslint-disable  */

  var changeAccordeonArea = function changeAccordeonArea(type) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['EmailReminderInteractionAnalytics'], params), [get(fields, 'data.item.title.jss.value', ''), type, 'open']);
    setReminderAccordionState(_objectSpread(_objectSpread({}, reminderAccordionState), {}, {
      visibleArea: type
    }));
  };

  /* eslint-enable  */

  var renderMediaPlaceholder = function renderMediaPlaceholder() {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "media-header-general",
      rendering: rendering
    });
  };
  var renderVariousLocationsLink = function renderVariousLocationsLink(locationAnalytics, params, name) {
    return /*#__PURE__*/React.createElement("a", {
      href: "#overview",
      className: "info-box-list__content para",
      "aria-label": "overview",
      "aria-labelledby": "overview",
      "data-cy": "link-various",
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickData(locationAnalytics, params), name);
      }
    }, dictionaries.get('SeveralLocations'));
  };
  var renderPlaceIdLink = function renderPlaceIdLink() {
    setShowLocationIcon(false);
    return /*#__PURE__*/React.createElement(React.Fragment, null);
    // return (
    //   <a
    //     href={googleMapUrl + placeIDfallback}
    //     className="info-box-list__content para"
    //     target="_blank"
    //     rel="noopener noreferrer"
    //     data-cy="link-place-id"
    //   >
    //     {placeID as any}
    //   </a>
    // );
  };
  var renderVenuesLink = function renderVenuesLink(locationAnalytics, params, name) {
    var validPlaceId = placeIDfallback ? placeIDfallback : singleVenuePlaceID;
    var validVenueAddress = singleVenueAddress;
    if (!validVenueAddress) {
      setShowLocationIcon(false);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
      href: googleMapUrl + validPlaceId,
      "aria-label": "Location",
      "aria-labelledby": "Location",
      target: "_blank",
      rel: "noopener noreferrer",
      className: "info-box-list__content para",
      "data-cy": "link-venues",
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickData(locationAnalytics, params), name);
      }
    }, validVenueAddress));
  };
  var runExtendedAnalytics = function runExtendedAnalytics(eventName) {
    tealiumClickFuncExtended(tealiumMergeClickData(buyTicketsClickAnalytics, params), eventName, {
      whats_on_event_name: titleForAnalytics.value,
      event_venue: get(venue, 'addressAnalytics.jss.value'),
      event_date: dateAnalytics,
      event_type: tagNameForAnalytics
    });
  };
  var renderBuyButton = function renderBuyButton(ticket) {
    var availableTickets = get(ticket, 'available.jss.value', false);
    var seller = ticket.ticketSeller.jss.value;
    var href = ticket.buyNowLink.jss.value.href;
    var priceRange = ticket.printPrice.jss.value;
    var titleOfShow = title ? title.value : '';
    var ctaText = availableTickets ? dictionaries.get('buyNow') || 'Buy now' : dictionaries.get('GoToEventDetailsWebsite') || 'More info';
    return /*#__PURE__*/React.createElement("a", {
      href: href,
      className: "tickets-cta-dd__book",
      "aria-label": "".concat(seller, " | ").concat(ctaText, " | ").concat(newWindowLabel),
      "aria-labelledby": "".concat(seller, " | ").concat(ctaText, " | ").concat(newWindowLabel),
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickData(buyNowMultipleTicketsClickAnalytics, params), [titleOfShow, seller, priceRange]);
      }
    }, ctaText);
  };
  var eventDateRangeString = get(fields, 'data.item.eventDatesRange.jss.value', '');
  var eventDateRangeParsed = eventDateRangeString && JSON.parse(eventDateRangeString);
  var eventStartDate = eventDateRangeParsed && eventDateRangeParsed.dates && eventDateRangeParsed.dates[0];
  var eventEndDate = eventDateRangeParsed && eventDateRangeParsed.dates && eventDateRangeParsed.dates[1];
  var locationSchema = '';
  var locationaddressSchema = '';
  if (defaultAddress) {
    locationaddressSchema = defaultAddress;
    locationSchema = defaultAddress;
  } else if (googlePlaceIDCollection.length === 0 && venueValues.length === 1) {
    var singleVenueTitle = get(venueValues[0], 'title.jss.value');
    var _singleVenueAddress = get(venueValues[0], 'address.jss.value');
    locationaddressSchema = _singleVenueAddress;
    locationSchema = singleVenueTitle;
  } else {
    locationSchema = dictionaries.get('SeveralLocations');
    locationaddressSchema = dictionaries.get('SeveralLocations');
  }
  // Popup Code Start
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showPopup = _useState20[0],
    setShowPopup = _useState20[1];
  var redirectURL = get(fields, 'data.listingPageConfiguration.listingPage.jss.url', '');
  var secondsToRedirect = 5;
  var _MS_PER_DAY = 1000 * 60 * 60 * 24;
  function dateDiffInDays(a, b) {
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
  }
  var hideDropdown, clickedOnAddToCalendar, ticketsBtnClickHandler, _ticketsDdCloseHandler;
  if (canUseDOM) {
    /* hideDropdown = () => {
      setDropdownState({
        show: false,
        left: 0,
        top: 0,
      });
    }; */

    /* clickedOnAddToCalendar = (event: any) => {
      if (event.target.classList.contains('chq-atc--button') === true) {
        // if the attribute exists...
          const boundingBox = event.target.getBoundingClientRect();
        let left = boundingBox.left;
        if (document.getElementsByTagName('html')[0].getAttribute('dir') === 'rtl') {
          left = boundingBox.right;
        }
        setDropdownState({
          show: true,
          left: left,
          top: boundingBox.top,
        });
      } else {
        hideDropdown();
      }
    }; */

    ticketsBtnClickHandler = function ticketsBtnClickHandler() {
      var titleOfShow = title ? title.value : '';
      if (!ticketsDdVisible) {
        setTicketsDdVisible(true);
        tealiumClickFunc(tealiumMergeClickData(buyMultipleTicketsClickAnalytics, params), [titleOfShow, "".concat(minPrice || 0, " - ").concat(maxPrice || 0)]);
        document.addEventListener('click', _ticketsDdCloseHandler);
      }
    };
    _ticketsDdCloseHandler = function ticketsDdCloseHandler(event) {
      if (!(event.target && event.target.closest('.tickets-cta-dd'))) {
        setTicketsDdVisible(false);
        document.removeEventListener('click', _ticketsDdCloseHandler);
      }
    };
  }
  React.useEffect(function () {
    var endDate = new Date(eventEndDate);
    var dateToday = new Date();
    endDate.setHours(0, 0, 0, 0);
    dateToday.setHours(0, 0, 0, 0);
    var difference = dateDiffInDays(endDate, dateToday);
    var interval = 200;
    var maxCheck = 2400;
    var time = 0;
    var actionBtn = document.querySelectorAll('.scroll-action-btn')[0];
    if (canUseDOM && rtl) {
      var clear = setInterval(function () {
        if (scrollRef.current) {
          actionBtn.click();
          sethideEvents(false);
          clearInterval(clear);
        }
        if (time >= maxCheck && hideEvents) {
          actionBtn.click();
          sethideEvents(false);
          clearInterval(clear);
        }
        time += interval;
      }, interval);
    }
    if (eventArchived) {
      setShowPopup(true);
    }
    if (difference > 0) {
      setShowPopup(true);
    }
    if (difference > 30) {
      setTimeout(function () {
        if (!pageEditing && !serverRole.includes('ContentManagement')) {
          window.location.href = redirectURL;
        }
      }, secondsToRedirect * 1000);
    }

    /* if (canUseDOM) {
      const clickedOnAddToCalendar = (event: any) => {
        if (event.target.classList.contains('chq-atc--button') === true) {
          // if the attribute exists...
            const boundingBox = event.target.getBoundingClientRect();
          let left = boundingBox.left;
          if (document.getElementsByTagName('html')[0].getAttribute('dir') === 'rtl') {
            left = boundingBox.right;
          }
          setDropdownState({
            show: true,
            left: left,
            top: boundingBox.top,
          });
        } else {
          setDropdownState({
            show: false,
            left: 0,
            top: 0,
          });
        }
      };
        document.addEventListener('click', clickedOnAddToCalendar);
      window.addEventListener('scroll', hideDropdown);
      window.addEventListener('resize', hideDropdown);
    } */

    return function () {
      /* if (canUseDOM) {
        // unmounting all events
        document.removeEventListener('click', clickedOnAddToCalendar);
        window.removeEventListener('scroll', hideDropdown);
        window.removeEventListener('resize', hideDropdown);
      } */
    };
  }, []);
  React.useEffect(function () {
    return function () {
      if (canUseDOM) {
        // unmounting close dropdown handler
        document.removeEventListener('click', _ticketsDdCloseHandler);
      }
    };
  }, []);

  // Popup Code End

  var _useState21 = useState(''),
    _useState22 = _slicedToArray(_useState21, 2),
    reminderQueryParamValue = _useState22[0],
    setReminderQueryParamValue = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    reminderPopupVisible = _useState24[0],
    setReminderPopupVisible = _useState24[1];
  useEffect(function () {
    if (canUseDOM && window.location.search) {
      var queryReminderParamValue = new URLSearchParams(window.location.search).get('reminder') || '';
      setReminderQueryParamValue(queryReminderParamValue);
      var queryParamEventStarted = new URLSearchParams(window.location.search).get('eventstarted') || '';
      setReminderPopupVisible(queryParamEventStarted === "true" ? true : false);
    }
  }, []);
  useEffect(function () {
    if (validEvents.length === 1) {
      if (reminderQueryParamValue === "1" || reminderQueryParamValue === "2" || reminderPopupVisible) {
        setReminderAccordionState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            visible: true
          });
        });
        if (reminderQueryParamValue === "1") {
          setReminderAccordionState(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              visibleArea: "calendar",
              isEmailBlockHidden: true
            });
          });
        }
      }
      setEventForReminder(_objectSpread(_objectSpread({}, eventObjForReminder), {}, {
        detailEventDateStart: validEvents[0].Date,
        detailEventDateEnd: validEvents[0].DateTo,
        numberOfDaysBeforeEventEnd: numberOfDaysBeforeEventEnd
      }));
    } else {
      (reminderQueryParamValue === "1" || reminderQueryParamValue === "2" || reminderPopupVisible) && setactivateEvents('show-events');
    }
  }, [reminderQueryParamValue, reminderPopupVisible]);
  var currentDateFormatted = function () {
    var currentDate = new Date(new Date().getTime());
    currentDate.setUTCHours(0, 0, 0, 0);
    return currentDate;
  }();
  var numberOfDaysBeforeEventEnd;
  if (validEvents.length === 1) {
    var eventDateTo = validEvents[0].DateTo;
    var eventDate = validEvents[0].Date;
    numberOfDaysBeforeEventEnd = differenceInDays(new Date(eventDateTo ? eventDateTo : eventDate), currentDateFormatted);
  }
  useEffect(function () {}, [reminderAccordionState, calendarReminderState, eventForReminder]);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement(StickyCtaAssistant, null), showPopup ? /*#__PURE__*/React.createElement(EventPopup, {
    heading: dictionaries.get('expiration header'),
    copy: dictionaries.get('expiration copy'),
    ctaLabel: dictionaries.get('expiration cta'),
    ctaLink: redirectURL
  }) : null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: "\n        {\n          \"@context\": \"https://schema.org\",\n          \"@type\": \"Event\",\n          \"name\": \"".concat(get(fields, 'data.item.title.jss.value', '').replace(/"/g, "'"), "\",\n          \"startDate\": \"").concat(eventStartDate, "\",\n          \"endDate\": \"").concat(eventEndDate, "\",\n          \"eventAttendanceMode\": \"https://schema.org/OfflineEventAttendanceMode\",\n          \"eventStatus\": \"https://schema.org/EventScheduled\",\n          \"location\": {\n            \"@type\": \"Place\",\n            \"name\": \"").concat(locationSchema && locationSchema.replace(/"/g, "'"), "\",\n            \"address\": {\n              \"@type\": \"PostalAddress\",\n              \"streetAddress\": \"").concat(locationaddressSchema && locationaddressSchema.replace(/"/g, "'"), "\"\n            }\n          },\n\n          \"description\": ").concat(JSON.stringify(get(fields, 'data.item.introText.jss.value')), "\n\n        }")
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-events"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 col-lg-7 col-xl-7"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-events__featured-image-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-events__mobileThemeLogo"
  }, theme && theme.dubai_calendar_logo && /*#__PURE__*/React.createElement("img", {
    className: "",
    src: BASE_URL + theme.dubai_calendar_logo + '?cx=0.5&cy=0.5&cw=125',
    alt: "Logo"
  })), process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder())), /*#__PURE__*/React.createElement("div", {
    className: "col-md-5 col-lg-5 col-xl-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-events__info"
  }, renderCurators(), /*#__PURE__*/React.createElement("div", {
    className: "header-events__label"
  }, tagName), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    className: "scroll-action-btn",
    ref: buttonRef,
    onClick: function onClick() {
      scrollRef.current && scrollRef.current.scrollToRight();
    }
  }, "scroll")), /*#__PURE__*/React.createElement("div", {
    className: "row header-events__header-panel"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-9"
  }, title && /*#__PURE__*/React.createElement(Text, {
    className: "header-events__title",
    tag: "h1",
    field: title
  }), introText && /*#__PURE__*/React.createElement(Text, {
    className: "body-small header-events__desc",
    tag: "p",
    field: introText
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, theme && theme.dubai_calendar_logo && /*#__PURE__*/React.createElement("img", {
    className: "header-events__title-img header-events__title-imgTheme",
    src: BASE_URL + theme.dubai_calendar_logo + '?cx=0.5&cy=0.5&cw=150',
    alt: "Logo"
  }), parentEventLogo && (parentEventLogoLink ? /*#__PURE__*/React.createElement("a", {
    href: parentEventLogoLink,
    "aria-label": "Logo",
    "aria-labelledby": "Logo"
  }, /*#__PURE__*/React.createElement("img", {
    className: "header-events__title-img",
    src: BASE_URL + parentEventLogo + '?cx=0.5&cy=0.5&cw=150&ch=150',
    alt: "Logo"
  })) : /*#__PURE__*/React.createElement("img", {
    className: "header-events__title-img",
    src: BASE_URL + parentEventLogo + '?cx=0.5&cy=0.5&cw=150&ch=150',
    alt: "Logo"
  })))), validEvents.length >= 1 && /*#__PURE__*/React.createElement("div", {
    className: "header-events__wrapper-list ".concat(hideEvents ? 'header-events__wrapper-list--hidden' : '')
  }, /*#__PURE__*/React.createElement(Scrollbars, {
    className: "scrollbar",
    ref: scrollRef,
    autoHeight: true,
    universal: true,
    style: {
      width: '100%',
      height: 110
    },
    renderTrackHorizontal: function renderTrackHorizontal(props) {
      return /*#__PURE__*/React.createElement("div", _extends({}, props, {
        className: "track-horizontal"
      }));
    },
    renderThumbHorizontal: function renderThumbHorizontal(props) {
      return /*#__PURE__*/React.createElement("div", _extends({}, props, {
        className: "thumb-horizontal"
      }), /*#__PURE__*/React.createElement("div", {
        className: "thumb-horizontal__inner"
      }));
    },
    onScrollStart: function onScrollStart() {
      return tealiumClickFunc(tealiumMergeClickData(sliderAnalytics, params), name);
    }
    /* onScroll={() => {
    hideDropdown();
    }} */,
    renderView: function renderView(props) {
      return /*#__PURE__*/React.createElement("div", _extends({}, props, {
        className: "view"
      }));
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-events__scroller2 header-events-length--".concat(validEvents.length),
    onScroll: function onScroll() {
      tealiumClickFunc(tealiumMergeClickData(sliderAnalytics, params), "".concat(dictionaries.get('SeeAllDates'), " : ").concat(name));
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-events__scroller-inner"
  }, renderEventDates(2, validEvents, venue), validEvents.length > 2 && /*#__PURE__*/React.createElement("div", {
    className: "header-events__see-wrapper"
  }, /*#__PURE__*/React.createElement("a", {
    className: "header-events__see-all",
    "aria-label": "See All Dates",
    "aria-labelledby": "See All Dates",
    onClick: function onClick(e) {
      tealiumClickFunc(tealiumMergeClickData(seeAllDatesClickAnalytics, params), "".concat(dictionaries.get('SeeAllDates'), " : ").concat(name));
      showEvents(e);
    },
    href: "/"
  }, dictionaries.get('SeeAllDates'), /*#__PURE__*/React.createElement(ChevronRightLight, {
    className: "header-events__chevron-icon news__more-icon"
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "header-events__info-box"
  }, !defaultAddress ? /*#__PURE__*/React.createElement(React.Fragment, null, (venueValues.length >= 1 || googlePlaceIDCollection.length >= 1) && showLocationIcon && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "info-box-list info-box-list__top ".concat(locationIcon)
  }, showLocationIcon && /*#__PURE__*/React.createElement("div", {
    className: "info-box-list__icon"
  }, /*#__PURE__*/React.createElement(LocationBlue, {
    className: "info-box-list__img"
  })), /*#__PURE__*/React.createElement("div", {
    className: "info-box-list__item"
  }, function () {
    if (googlePlaceIDCollection.length === 1 && venueValues.length === 0) return renderPlaceIdLink();else if (googlePlaceIDCollection.length === 0 && venueValues.length === 1) return renderVenuesLink(locationAnalytics, params, name);else return renderVariousLocationsLink(locationAnalytics, params, name);
  }())))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "info-box-list info-box-list__top ".concat(locationIcon)
  }, showLocationIcon && /*#__PURE__*/React.createElement("div", {
    className: "info-box-list__icon"
  }, /*#__PURE__*/React.createElement(LocationBlue, {
    className: "info-box-list__img"
  })), /*#__PURE__*/React.createElement("div", {
    className: "info-box-list__item"
  }, defaultAddress))), (isFree || minPrice || minPrice || ticketPrice || ticketsAvailable) && /*#__PURE__*/React.createElement("div", {
    className: "info-box-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "info-box-list__icon"
  }, /*#__PURE__*/React.createElement(Ticket, {
    className: "info-box-list__img"
  })), /*#__PURE__*/React.createElement("div", {
    className: "info-box-list__item"
  }, /*#__PURE__*/React.createElement("p", {
    className: "info-box-list__content"
  }, renderPriceBlock())))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col static-on-mobile d-flex"
  }, tickets.length ? /*#__PURE__*/React.createElement("div", {
    className: "button-links-box"
  }, /*#__PURE__*/React.createElement("button", {
    className: "tickets-cta btn btn-primary",
    onClick: ticketsBtnClickHandler
  }, /*#__PURE__*/React.createElement("div", {
    className: "tickets-cta__title"
  }, dictionaries.get('BuyTickets')), /*#__PURE__*/React.createElement("div", {
    className: "tickets-cta__price"
  }, "\n                                    ".concat(dictionaries.get('AED'), " ").concat(minPrice || 0, " - ").concat(maxPrice || 0, "\n                                  ")), /*#__PURE__*/React.createElement("span", {
    className: "tickets-cta__arrow"
  }, /*#__PURE__*/React.createElement(ChevronUp, {
    width: 28,
    height: 28
  }))), /*#__PURE__*/React.createElement("div", {
    className: "\n                                tickets-cta-dd\n                                ".concat(ticketsDdVisible ? 'tickets-cta-dd--visible' : '', "\n                              ")
  }, /*#__PURE__*/React.createElement("ul", {
    className: "tickets-cta-dd__list"
  }, tickets[0].ticket.map(function (ticket, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: "".concat(ticket.ticketSeller.jss.value, "-").concat(index)
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      className: "tickets-cta-dd__seller"
    }, ticket.ticketSeller.jss.value), /*#__PURE__*/React.createElement("p", {
      className: "tickets-cta-dd__price-range"
    }, ticket.printPrice.jss.value)), renderBuyButton(ticket));
  })))) : (buyLink || buyLinkMobile || venueWebsite) && /*#__PURE__*/React.createElement("div", {
    className: "button-links-box m-0 flex-grow-0"
  }, isChina && venueWebsite && /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-primary btn-primary--large",
    href: createRouterLink(buyLink, accessToken, venueWebsite, isTicketing),
    onClick: function onClick() {
      runExtendedAnalytics(name);
    },
    title: dictionaries.get('GoToEventDetailsWebsite')
  }, dictionaries.get('GoToEventDetailsWebsite')), !isChina && !buyLinkMobile && /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-primary btn-primary--large",
    href: createRouterLink(buyLink, accessToken, venueWebsite, isTicketing),
    onClick: function onClick() {
      runExtendedAnalytics(name);
    },
    title: buyLink ? dictionaries.get('BuyTickets') : dictionaries.get('GoToEventDetailsWebsite')
  }, buyLink ? dictionaries.get('BuyTickets') : dictionaries.get('GoToEventDetailsWebsite')), !isChina && buyLink && buyLinkMobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-primary btn-primary--large d-md-inline-block d-none",
    href: createRouterLink(buyLink, accessToken, venueWebsite, isTicketing),
    onClick: function onClick() {
      runExtendedAnalytics(buyLink);
    },
    title: buyLink ? dictionaries.get('BuyTickets') : dictionaries.get('GoToEventDetailsWebsite')
  }, dictionaries.get('BuyTickets')), /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-primary btn-primary--large d-md-none",
    href: createRouterLink(buyLinkMobile, accessToken, venueWebsite, isTicketing),
    onClick: function onClick() {
      runExtendedAnalytics(buyLink);
    },
    title: dictionaries.get('BuyTickets')
  }, dictionaries.get('BuyTickets')))), /*#__PURE__*/React.createElement("div", {
    className: "fav-btn-box"
  }, /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: moduleId,
    classes: ' header-events__fav-btn my-icon-white d-md-inline-block',
    analyticsClick: function analyticsClick(action) {
      tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), "".concat(action, " : ").concat(name));
    }
  }))))))), validEvents.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: "events-overlay ".concat(activateEvents)
  }, /*#__PURE__*/React.createElement("div", {
    className: "events-overlay__header"
  }, /*#__PURE__*/React.createElement("a", {
    className: "events-overlay__close-btn d-none d-md-block",
    onClick: function onClick(e) {
      return closeEvents(e);
    },
    href: "/",
    "aria-label": "close",
    "aria-labelledby": "close"
  }, /*#__PURE__*/React.createElement("img", {
    className: "events-overlay__close-btn-img",
    src: closeWhite,
    alt: "close"
  })), /*#__PURE__*/React.createElement("a", {
    className: "events-overlay__back-btn d-block d-md-none",
    onClick: function onClick(e) {
      return closeEvents(e);
    },
    href: "/",
    "aria-label": "back",
    "aria-labelledby": "back"
  }, /*#__PURE__*/React.createElement("img", {
    className: "events-overlay__back-btn-img",
    src: arrowLeftnoborderWhite,
    alt: "back"
  })), title && /*#__PURE__*/React.createElement(Text, {
    className: "events-overlay__title h2",
    tag: "h3",
    field: title
  })), /*#__PURE__*/React.createElement("div", {
    className: "events-overlay__scroller"
  }, /*#__PURE__*/React.createElement("div", {
    className: "events-overlay__list-wrapper"
  }, validEvents && validEvents.length && renderListDate()))), /*#__PURE__*/React.createElement("div", {
    className: "reminder-accordion-overlay ".concat(reminderAccordionState.visible ? 'reminder-accordion-overlay--visible' : '')
  }), /*#__PURE__*/React.createElement("div", {
    className: "reminder-accordion-wrapper ".concat(reminderAccordionState.visible ? 'reminder-accordion-wrapper--visible' : '')
  }, /*#__PURE__*/React.createElement("h3", {
    className: "reminder-accordion__header ".concat(isOpenReminderCalendarPicker && 'reminder-accordion__header-fix')
  }, setReminderLabel, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setReminderAccordionState(_objectSpread(_objectSpread({}, reminderAccordionState), {}, {
        isEmailBlockHidden: false
      }));
      setReminderAccordionState(_objectSpread(_objectSpread({}, reminderAccordionState), {}, {
        visible: false
      }));
    },
    className: "reminder-accordion__header-close btn--reset"
  }, /*#__PURE__*/React.createElement(IconClose, {
    className: "icon"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "reminder-accordion__list"
  }, /*#__PURE__*/React.createElement("button", {
    className: " \n                        reminder-accordion__list-opener btn--reset\n                        ".concat(reminderAccordionState.visibleArea === 'email' ? 'reminder-accordion__list-opener--opened' : '', "\n                        ").concat(isOpenReminderCalendarPicker && 'btn--hidden', "\n                        ").concat(reminderAccordionState.isEmailBlockHidden ? 'this-block--hidden' : '', "\n                      "),
    onClick: function onClick() {
      changeAccordeonArea('email');
    }
  }, emailReminderLabel, reminderAccordionState.visibleArea === 'email' ? /*#__PURE__*/React.createElement(MinusIcon, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(PlusIcon, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "\n                      ".concat(reminderAccordionState.isEmailBlockHidden ? 'this-block--hidden' : '', " \n                      reminder-accordion__list-content")
  }, /*#__PURE__*/React.createElement("div", {
    className: "reminder-accordion__list-content-intro ".concat(isOpenReminderCalendarPicker && 'btn--hidden')
  }, /*#__PURE__*/React.createElement(EmailBigIcon, {
    className: "icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "separator"
  }), /*#__PURE__*/React.createElement("div", {
    className: "reminder-accordion__list-content-intro-text"
  }, accordeonIntroLabel)), /*#__PURE__*/React.createElement(Reminder, {
    lang: currentLang,
    event: eventForReminder,
    eventDetail: true,
    eventsAnalytics: eventsAnalytics,
    location: get(venue, 'title.jss.value'),
    countryItems: countryItems,
    hidableMode: false,
    params: params,
    externalSuccessCallback: function externalSuccessCallback() {
      setReminderAccordionState(_objectSpread(_objectSpread({}, reminderAccordionState), {}, {
        visible: false
      }));
    },
    reminderAccordionStateValue: reminderAccordionState.visibleArea,
    setIsOpenReminderCalendarPicker: setIsOpenReminderCalendarPicker,
    setReminderAccordionState: setReminderAccordionState,
    numberOfDaysBeforeEventEnd: numberOfDaysBeforeEventEnd
  })), /*#__PURE__*/React.createElement("button", {
    className: "\n                        reminder-accordion__list-opener btn--reset                      \n                        ".concat(reminderAccordionState.visibleArea === 'calendar' ? 'reminder-accordion__list-opener--opened' : '', "\n                      "),
    onClick: function onClick() {
      changeAccordeonArea('calendar');
      setIsOpenReminderCalendarPicker(false);
    }
  }, calendarReminderLabel, reminderAccordionState.visibleArea === 'calendar' ? /*#__PURE__*/React.createElement(MinusIcon, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(PlusIcon, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "reminder-accordion__list-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reminder-accordion__list-content-intro"
  }, /*#__PURE__*/React.createElement(CalendarBigIcon, {
    className: "icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "separator"
  }), /*#__PURE__*/React.createElement("div", {
    className: "reminder-accordion__list-content-intro-text"
  }, accordeonIntroLabel)), /*#__PURE__*/React.createElement("div", {
    className: "calendar-reminder-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    className: "\n                            calendar-reminder__dd-btn btn--reset\n                            ".concat(calendarReminderState.visible ? 'calendar-reminder__dd-btn--opened' : '', "\n                          "),
    onClick: function onClick() {
      setCalendarReminderState(_objectSpread(_objectSpread({}, calendarReminderState), {}, {
        visible: true
      }));
      tealiumClickFunc(tealiumMergeClickData(addToCalendarClickAnalytics, params), name);
    }
  }, calendarReminderState.selectedString || selectMediaLabel, ' ', /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  })), calendarReminderState.visible && /*#__PURE__*/React.createElement("ul", {
    className: "calendar-reminder__dd-variants-list"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    disabled: true,
    className: "calendar-reminder__dd-variant btn--reset"
  }, selectMediaLabel)), !isChina && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['CalendarReminderSelectEmailAnalytics'], params), [get(fields, 'data.item.title.jss.value', ''), 'Google']);
      setCalendarReminderState({
        value: 'google',
        selectedString: 'Google',
        visible: false
      });
    },
    className: "calendar-reminder__dd-variant btn--reset"
  }, ReminderGoogle)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['CalendarReminderSelectEmailAnalytics'], params), [get(fields, 'data.item.title.jss.value', ''), 'Outlook Web App']);
      setCalendarReminderState({
        value: 'outlook',
        selectedString: 'Outlook Web App',
        visible: false
      });
    },
    className: "calendar-reminder__dd-variant btn--reset"
  }, ReminderOutlookWebApp)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['CalendarReminderSelectEmailAnalytics'], params), [get(fields, 'data.item.title.jss.value', ''), 'Outlook']);
      setCalendarReminderState({
        value: 'ics',
        selectedString: 'Outlook',
        visible: false
      });
    },
    className: "calendar-reminder__dd-variant btn--reset"
  }, ReminderOutlook)), !isChina && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['CalendarReminderSelectEmailAnalytics'], params), [get(fields, 'data.item.title.jss.value', ''), 'yahoo']);
      setCalendarReminderState({
        value: 'yahoo',
        selectedString: 'Yahoo',
        visible: false
      });
    },
    className: "calendar-reminder__dd-variant btn--reset"
  }, ReminderYahoo))), /*#__PURE__*/React.createElement("div", {
    className: "calendar-reminder__submit-wrapper"
  }, /*#__PURE__*/React.createElement("a", {
    href: currentUrls[calendarReminderState.value] || '#',
    target: "_blank",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['EmailReminderInteractionAnalytics'], params), [get(fields, 'data.item.title.jss.value', ''), dictionaries.get('AddToCalendar'), calendarReminderState.value]);
    },
    "aria-label": newWindowLabel,
    "aria-labelledby": newWindowLabel,
    rel: "noopener noreferrer",
    className: "btn btn-primary ".concat(!!calendarReminderState.selectedString ? '' : 'btn-disabled')
  }, dictionaries.get('AddToCalendar'))))))))))))));
};
var StyledWrapper = function StyledWrapper(_ref4) {
  var children = _ref4.children,
    rtl = _ref4.rtl;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "\n      ".concat(addToCalendarDropdown, "\n      ").concat(headerCommonStyle, "\n      ").concat(rtl ? rtlStyles : ltrStyles, "\n      ").concat(headerImageStyle, "\n      ").concat(scrollbarStyles, "\n      ").concat(ticketstStyles, "\n      ").concat(remindAccordionStyles)
  }, children);
};
var headerCommonStyle = "h10132if";
var addToCalendarDropdown = "a1cin5gz";
var scrollbarStyles = "s1mk7ejx";
var ticketstStyles = "t10mhlhg";
var remindAccordionStyles = "rbuxjmj";
var ltrStyles = "l1l03pmx";
var rtlStyles = "r1yzush8";
export default EventHeader;